import { UserProfileMin } from 'src/app/authentication/profile/models/user-profile-min';
import { ImgDb } from '../../img-db/model/img-db';
import { Project } from '../../project/models/project';

export enum ContainerType {
    IMAGE_DB = 'IMAGE_DB',
    PROJECT_MOTORIC = 'PROJECT_MOTORIC',
    PROJECT_VISUAL = 'PROJECT_VISUAL',
}

export enum MembershipStatus {
    OWNER = 'OWNER',
    MEMBER = 'MEMBER',
    NONE = 'NONE',
    REQUESTED = 'REQUESTED',
}

export enum Accessibility {
    CLOSED = 'CLOSED',
    OPEN = 'OPEN',
}

export enum Visibility {
    PRIVATE = 'PRIVATE',
    GROUP = 'GROUP',
    ORG = 'ORG',
    PUBLIC = 'PUBLIC',
}

export interface CollaborationOptionsDto {
    visibility: Visibility;
    accessibility: Accessibility;
}

export interface Container {
    id: string; //uuid
    name: string;
    collaborationOptionsDto: CollaborationOptionsDto;
    containerType: ContainerType;
    creator: string;
    membershipStatus: MembershipStatus;
    description?: string;
    containerImage?: string;
    imageDb?: ImgDb;
    project?: Project;
    canNotBeDeleted?: boolean;
    organizationId?: string;
    groupId?: string;
}

export interface ContainerPage {
    values: Container[];
    currentPage: number;
    totalElements: number;
    totalPages: number;
    users: UserProfileMin[];
}

export interface ContainerCreateResponse {
    id: string;
    name: string;
}

export class ContainerCreateRequest {
    name: string;
    collaborationOptionsDto: CollaborationOptionsDto;
    containerType: ContainerType;
    description?: string;

    parameter?: string;
    defaultTrainingName?: string;
    groupId?: string | null;
}

export interface ContainerMembership {
    memberId: string;
    memberName: string;
    roleName: string;
    memberSince: Date;
}

export interface ContainerJoinRequestAnswer {
    containerId: string;
    displayNames: string[];
    accepted: boolean;
    acceptedGrantingUsageRights: boolean;
}

export class ContainerJoinRequest {
    containerId: string;
    userAccountDisplayName: string;
}

export class ContainerJoinRequestList {
    values: ContainerJoinRequest[];
}
